import { Sidebar } from './Sidebar';
import { Toaster } from '@/components/ui/sonner';

export function Layout({ children }) {
  return (
    <div className="dark flex h-screen overflow-hidden bg-[#09090b]">
      <Sidebar />
      <main className="flex-1 overflow-y-auto w-full">
        <div className="p-4 md:p-6">
          {children}
        </div>
      </main>
      <Toaster position="top-right" />
    </div>
  );
}
